import React, { useState, useEffect } from "react";
import { getAssets } from "@unisearch/helpers";
import dynamic from "next/dynamic";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import styles from "./uni_hero_with_video.module.scss";
import Image from "next/legacy/image";

export const UniHeroWithVideo = ({ uniProfileData }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <section className={styles.uni_hero}>
      <div className="container">
        <div className={styles.video_wrapper}>
          <div className={styles.overlay}></div>
          <Image
            layout="responsive"
            width={840}
            height={450}
            blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
            placeholder="blur"
            className={styles.featured_image}
            src={
              uniProfileData?.coverphotoLogoSrc ||
              getAssets("assets/images/image_placeholder_big.webp")
            }
            alt="Video Background"
          />
          <PlayButtonWithRipple onClick={() => setOpen(true)} />
        </div>
      </div>

      {uniProfileData?.videoType === "upload" && (
        <ModalVideo
          channel="custom"
          autoplay
          isOpen={isOpen}
          url={uniProfileData ? uniProfileData.videoSrc : ""}
          onClose={() => setOpen(false)}
        />
      )}

      {uniProfileData?.videoType === "embeded" && (
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId={uniProfileData ? uniProfileData.embedCode : ""}
          onClose={() => setOpen(false)}
        />
      )}
    </section>
  );
};

export default UniHeroWithVideo;
